var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"video-container"},[_c('video',{ref:"video",attrs:{"autoplay":"","playsinline":""}}),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCompleted),expression:"!isCompleted"}],ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }